/** Libellés français affichés par la PWA (source unique). */

export const TASK_TYPE_LABELS = {
  PROMO: "Mettre en promo",
  POSTER: "Poser une affiche",
  DISPLAY: "Mise en avant vitrine/caisse",
  RESTOCK: "Réassort / contrôle stock",
  ARRIVAL: "Créer l'arrivage",
  FREE: "Tâche libre",
} as const;

export const TASK_PRIORITY_LABELS = { LOW: "Basse", NORMAL: "Normale", HIGH: "Haute" } as const;

export const TASK_STATUS_LABELS = {
  SENT: "Envoyée",
  SEEN: "Vue",
  IN_PROGRESS: "En cours",
  DONE: "Faite",
  VALIDATED: "Validée",
  REFUSED: "Refusée",
} as const;

export type TaskStatusKey = keyof typeof TASK_STATUS_LABELS;

/** Une tâche est « en retard » si elle n'est pas faite et que l'échéance est passée. */
export function isTaskLate(status: TaskStatusKey, dueAt: Date | string | null | undefined, now = new Date()): boolean {
  if (status === "DONE" || status === "VALIDATED") return false;
  if (!dueAt) return false;
  const d = typeof dueAt === "string" ? new Date(dueAt) : dueAt;
  return d.getTime() < now.getTime();
}

export function isTaskOpen(status: TaskStatusKey): boolean {
  return status !== "DONE" && status !== "VALIDATED";
}

export const SHOP_TYPE_LABELS = { INTEGRATED: "Intégrée", FRANCHISE: "Franchise" } as const;

export const PERIOD_LABELS = {
  jour: "aujourd'hui",
  semaine: "cette semaine",
  mois: "ce mois-ci",
  annee: "cette année",
} as const;

export const PERIOD_PILLS = { jour: "Jour", semaine: "Semaine", mois: "Mois", annee: "Année" } as const;

export const COMPARE_LABELS = { j7: "vs J-7", m1: "vs M-1", n1: "vs N-1" } as const;

export const ABSENCE_TYPE_LABELS = { LEAVE: "Congé", SICK: "Maladie", TRAINING: "Formation", OTHER: "Absence" } as const;
